export default __webpack_public_path__ + "static/media/gteng01.45bc09a3.png";